import { render } from "./CPKSelector.vue?vue&type=template&id=1638d6a7"
import script from "./CPKSelector.vue?vue&type=script&lang=js"
export * from "./CPKSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__